import { render } from "./content-placeholders-text.vue?vue&type=template&id=602b27bd&ts=true"
import script from "./content-placeholders-text.vue?vue&type=script&lang=ts"
export * from "./content-placeholders-text.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__